import { render, staticRenderFns } from "./AccountingArchivedList.vue?vue&type=template&id=fde4606e&"
import script from "./AccountingArchivedList.vue?vue&type=script&lang=js&"
export * from "./AccountingArchivedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports